import './Navbar.scss';
import { routes, RouteItem, otherRoutes } from '../../coreModules/coreFiles/routes';
import { useState, useEffect, useCallback } from 'react';
import logo from '../../../assets/logo.png';
import { useLocation, useNavigate } from 'react-router-dom';

interface Section {
    id: string;
    label: string;
    element: HTMLElement;
}

function NavBar() {
    const [activeNav, setActiveNav] = useState(routes[0].label);
    const offset = 150;

    const navigate = useNavigate();
    const location = useLocation();
    const goToContactUs = () => {
        window.scrollTo(0, 0);
        navigate("/contact");
    }

    const goToSection = (item: RouteItem) => {
        setActiveNav(item.label);
        const element = document.getElementById(item.id);

        if (element) {
            const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
            const offsetPosition = elementPosition - offset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth',
            });
        } else {
            sessionStorage.setItem('scrollToElement', item.id);
            navigate('/');
        }
    };

    useEffect(() => {
        const scrollToElementId = sessionStorage.getItem('scrollToElement');

        if (scrollToElementId) {
            sessionStorage.removeItem('scrollToElement');

            const timeoutId = setTimeout(() => {
                const targetElement = document.getElementById(scrollToElementId);

                if (targetElement) {
                    const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
                    const offsetPosition = elementPosition - offset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth',
                    });
                }
            }, 500);

            return () => clearTimeout(timeoutId);
        }
    }, [location]);

    const debounce = (func: Function, wait: number) => {
        let timeout: NodeJS.Timeout;
        return (...args: any[]) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func(...args), wait);
        };
    };

    const handleScroll = useCallback(() => {
        const sections = routes.map(route => ({
            id: route.id,
            label: route.label,
            element: document.getElementById(route.id)
        })).filter((section): section is Section =>
            section.element !== null
        );

        let maxVisibleSection: any = null;
        let maxVisibleHeight = 0;

        sections.forEach(section => {
            const rect = section.element.getBoundingClientRect();
            const visibleHeight = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);

            if (visibleHeight > maxVisibleHeight) {
                maxVisibleHeight = visibleHeight;
                maxVisibleSection = section;
            }
        });

        if (maxVisibleSection && maxVisibleSection.label !== activeNav) {
            setActiveNav(maxVisibleSection.label);
        }
    }, [activeNav]);

    useEffect(() => {
        const debouncedScroll = debounce(handleScroll, 100);
        window.addEventListener('scroll', debouncedScroll);

        return () => {
            window.removeEventListener('scroll', debouncedScroll);
        };
    }, [handleScroll]);

    return (
        <div className={`alpha-perceptron-navbar`}>
            <div className='alpha-perceptron-navbar__logo' onClick={()=> goToSection(otherRoutes[0])}>
                <img src={logo} alt='AlphaPerceptron' />
            </div>
            {routes.map((item: RouteItem) =>
                <div
                    key={item.id}
                    onClick={() => goToSection(item)}
                    className={`alpha-perceptron-navbar__navItem`}>
                    {item.label || 'NA'}
                    {activeNav === item.label ?
                        <div className={`alpha-perceptron-navbar__activeNavItem`} /> :
                        <div className={`alpha-perceptron-navbar__inActiveNavItem`} />}
                </div>)}
            <div className='alpha-perceptron-navbar__contact-us' onClick={goToContactUs}>
                Contact Us
            </div>
        </div>
    );
}

export default NavBar;